"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAY_MASK = exports.YEAR_MASK = exports.PHONE_MASK = exports.PHONE_MASK_RU_EIGHT = exports.PHONE_MASK_RU = void 0;
var PHONE_MASK_RU = ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
exports.PHONE_MASK_RU = PHONE_MASK_RU;
var PHONE_MASK_RU_EIGHT = ['8', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
exports.PHONE_MASK_RU_EIGHT = PHONE_MASK_RU_EIGHT;
var PHONE_MASK = ['+', /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
exports.PHONE_MASK = PHONE_MASK;
var YEAR_MASK = [/\d/, /\d/, /\d/, /\d/];
exports.YEAR_MASK = YEAR_MASK;
var DAY_MASK = [/\d/, /\d/];
exports.DAY_MASK = DAY_MASK;